import React from "react";

const TemplateCardSkeleton = () => (
    <div
        className="flex flex-col rounded-xl border border-gray-100 bg-white p-4"
        aria-hidden="true"
    >
        <div className="h-5 w-3/4 rounded bg-gray-100 animate-pulse" />
        <div className="mt-1.5 h-4 w-1/2 rounded bg-gray-100 animate-pulse" />
        <div className="mt-8 flex items-center justify-between gap-3">
            <div className="h-4 w-1/3 rounded bg-gray-100 animate-pulse" />
            <div className="h-4 w-16 rounded bg-gray-100 animate-pulse" />
        </div>
    </div>
);

export default TemplateCardSkeleton;
